import React                                                        from 'react';
import { withStyles }                                               from '@material-ui/core/styles';
import { globales,funciones,colores}                                from '../../global';
import AuthService                                                  from '../../AuthService';
import Request                                                      from 'superagent';
import CustomTable                                                  from '../../components/CustomTable';
import {Table}                                                      from '@devexpress/dx-react-grid-material-ui';
import TableRowsIndexer                                             from '../../components/tableRowsIndexer'
import CircularProgress                                             from '@material-ui/core/CircularProgress';
import Backdrop                                                     from '@material-ui/core/Backdrop';
import { KeyboardDatePicker, MuiPickersUtilsProvider }              from "@material-ui/pickers";
import DateFnsUtils                                                 from "@date-io/date-fns";
import esLocale                                                     from "date-fns/locale/es";
import CustomToolbar                                                from '../../components/toolbarPicker'; 

let Auth = new AuthService();
var ip=globales.ip
var border_dialog=globales.border_dialog
var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
var movil_pequeño=/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

let isVisibleRowSelected = false;

const VirtualTable_cellComponent = (props) => {
    const { column }    = props;
    const {row}         = props;

    if(column.name==='MONTO'){
        return(
            <Table.Cell {...props}>
                {row.SIMBOLO+' '+row.MONTO}
            </Table.Cell>
        );
    }

    return(
        <Table.Cell {...props}/>
    );
}

const VirtualTable_cellComponent_detalle = (props) => {
    const {column}    = props;
    const {row}       = props;  

    if(column.name==='MONTO_DTL'||column.name==='MONTO_TOTAL'||column.name==='MONTO_BEC_CREDITO'||column.name==='MONTO_MORA'||column.name==='FINANCIADO')
    {
        return(<Table.Cell {...props}>{row.SIMBOLO+' '+(row[column.name]===0?'0.00':row[column.name])}</Table.Cell>);
    }

    return(<Table.Cell {...props}/>);
}

const getRowId = row => row.ID_FACTURA;
const getRowId_detalle = row => row.ID_DETALLE;



/*                           CLASES DE ESTILO                       */

var styles = theme =>({
    Dialog:{
        borderRadius: border_dialog,
        margin:0,
        padding:0
    },
    backdrop: {
      zIndex: 500000,
      color: '#fff', 
      flexDirection: 'column'
    },
    select: { //CONFIGURA EL SELECT 
        margin: theme.spacing(movil_pequeño?2:1, 1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'50%',
      },
      textField: {
        margin: theme.spacing(movil_pequeño?0:1, movil_pequeño?0:1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'20%',
        width: '20%'      
      },
    })

    const columns= [{name:'ID_FACTURA',title: 'Factura'},
    {name:'FECHA_PROCESO',title: 'Fecha'},
    {name:'DESCRIPCION',title: 'Descripción'},
    {name:'REFERENCIA1',title: 'Referencia'},
    {name:'MONTO',title: 'Monto'},    
    ];

    const columns_detalle= [{name:'ID_DETALLE',title: 'ID_DETALLE'},
    {name:'DESCRIPCION_DTL',title: 'Descripción'},
    {name:'MONTO_TOTAL',title: 'Total'},
    {name:'MONTO_DTL',title: 'Monto'},
    {name:'MONTO_MORA',title: 'Mora'},
    {name:'MONTO_BEC_CREDITO',title: 'Bec | Crédito'},
    {name:'FINANCIADO',title: 'Financiado'},
    ];

    const defaultHiddenColumnNames= [];
    const defaultHiddenColumnNames_detalle= ['ID_DETALLE'];

    const tableColumnExtensions= [
        { columnName: 'ID_FACTURA', wordWrapEnabled: false, align: 'center',width:100},
        { columnName: 'FECHA_PROCESO', wordWrapEnabled: false, align: 'center',width:100},
        { columnName: 'DESCRIPCION', wordWrapEnabled: true, align: 'left',width:window.innerWidth/2},
        { columnName: 'REFERENCIA1', wordWrapEnabled: false, align: 'center',width:100},
        { columnName: 'MONTO', wordWrapEnabled: false, align: 'left',width:100},
    ];

    const tableColumnExtensions_detalle= [
        { columnName: 'DESCRIPCION_DTL', wordWrapEnabled: false, align: 'left',width:300},
        { columnName: 'MONTO_TOTAL', wordWrapEnabled: false, align: 'left',width:100},
        { columnName: 'MONTO_DTL', wordWrapEnabled: false, align: 'left',width:100},
        { columnName: 'MONTO_MORA', wordWrapEnabled: false, align: 'left',width:100},
        { columnName: 'MONTO_BEC_CREDITO', wordWrapEnabled: false, align: 'left',width:100},
        { columnName: 'FINANCIADO', wordWrapEnabled: false, align: 'left',width:100},
    ];

    const rowHeaderRowComponent = ({style, ...props}) => {
        return (<Table.Row style={{ backgroundColor: colores.tabla.encabezado }} {...props} />);
    }
        
        
      

/*                                        EXPORT                                      */
export default withStyles(styles)(
    class Historico_Pago extends React.Component {
      tablaRef = React.createRef();

      constructor(props) {
        super(props);
        this.l= props.l
        this.e= props.e
        this.i= props.i
        this.isVisibleRowSelected=isVisibleRowSelected
        this.actualizarbarra=props.actualizarbarra
        this.actualizarcircular=props.actualizarcircular

        this.state = {
            fechadesde: null,
            fechahasta: null,
            cargando:      false, 
            isLoggin:          undefined,
            heightTableMain:    0,
            rows: [],
            rows_principal: [],
            rows_detalle:      [],
            selection: [],
            grouping: [],
            expandedGroups: [],
            filteringColumnExtensions: [],
            filters: [],
            expandedRowIds: [],
            enabledFilterRows: true
        }

        const RowDetail= ({ row }) => {

            var rows_detalle=[]
            var height='170px'

            rows_detalle = this.state.rows.filter(grupo => grupo.ID_FACTURA === row.ID_FACTURA);
            
            if(rows_detalle.length===1)
            height='86px'
            else if(rows_detalle.length===2)
            height='120px'
            else if(rows_detalle.length===3)
            height='150px'

            return(
                <div style={{position: 'relative', zIndex:10}}>
                <CustomTable
                    Columns={columns_detalle}                                    
                    Rows={rows_detalle}                                          
                    TableColumnExtensions={tableColumnExtensions_detalle}
                    DefaultHiddenColumnNames={defaultHiddenColumnNames_detalle}
                    rowHeaderRowComponent={rowHeaderRowComponent}
                    getRowId = {getRowId_detalle}
                    height={height}
                    enabledFilterRows= {false}
                    standarPlugin = { <TableRowsIndexer/> }
                    VirtualTable_cellComponent={VirtualTable_cellComponent_detalle}
                    showSelectionColumn={false}
                />
                </div>
            )
        }
        this.RowDetail=RowDetail
        
    }; //FIN CONSTRUCTORS



componentDidMount()
{
        let _this = this;
        _this.actualizarbarra(false)

        Auth.loggedIn().then( function(b){
            _this.setState({ isLoggin: b})
            if(b)
            _this.setState({rows: [], heightTableMain:   funciones.getHeightTableMain(movil_pequeño,_this).heightTable})   
            _this.actualizarbarra(true)
        })
}

handleDateChange_desde=(date)=>{
    if(date>this.state.fechahasta && this.state.fechahasta!==null){
    funciones.showToast('w','La fecha de inicio debe ser menor a la final.');
    return;
    }
    this.setState({ fechadesde: date },()=>{
        if(this.state.fechahasta!==null&&this.state.fechahasta!==undefined)
        this.llenar_tabla()
    }); 

}

handleDateChange_hasta=(date)=>{
    if(date<this.state.fechadesde){
        funciones.showToast('w','La fecha de inicio debe ser menor a la final.');
        return;
    }
    this.setState({ fechahasta: date,cargando: true }, ()=>{
        this.llenar_tabla()
    })
        
}

llenar_tabla=()=>{
    let _this = this;

    const fecha_ini = funciones.getDateSelect(new Date(this.state.fechadesde + (!movil?" UTC":"")));
        const fecha_fin = funciones.getDateSelect(new Date(this.state.fechahasta + (!movil?" UTC":"")));
        this.setState({cargando:true},()=>{
            Request.get(`${ip}/HistoricoPago_Alumno/obtener_historico_pago/${fecha_ini}/${fecha_fin}/${Auth.getProfile().user}`)
            .set({'authorization': 'Bearer ' + Auth.getToken() })
            .retry(1)
            .timeout({ response: 20000, deadline: 50000, }) 
            .end((err, res)=> {
             if (err) { 
                    if (err.toString().substr(0,16) === 'Error: Forbidden')
                    {
                      window.location.reload();
                      return;  
                    }
                    (async function() {
                        funciones.showToast('e','Error de conexión')
                    })();//FIN FUNCION ASYNC
                    _this.setState({ cargando: false});
                    return;
            }
            const tmp = JSON.parse(res.text);
            if(tmp.length>0){
                var found
                var rows_principal=[]
                tmp.forEach(
                  function getCheck(item, index) {
                    found = rows_principal.find(grupo => grupo.ID_FACTURA === item.ID_FACTURA);
                if (found==null){
                    rows_principal.push(item);
                }
                else{
                  found=null;
                }
                })
                
                    _this.setState({ cargando: false,rows:tmp,rows_principal: rows_principal,heightTableMain: funciones.getHeightTableMain(movil_pequeño,_this).heightTable}); 
                }
                else
                {
                    _this.setState({cargando: false,rows: [],rows_principal:[], heightTableMain:   funciones.getHeightTableMain(movil_pequeño,_this).heightTable})
                }
          })
        })
}

onExpandedRowDetailIdsChange = expandedRowIds =>
{
    var expandedRowIds2=[]

    if(expandedRowIds.length>1)
    expandedRowIds2=[expandedRowIds[1]]
    else
    expandedRowIds2=[expandedRowIds[0]]
    
    this.setState({ expandedRowIds:expandedRowIds2 });
};

/*                                          RENDER                          */
render() {
    const { classes } = this.props;

    if (this.state.isLoggin === true )
    {
    return (    
    <React.Fragment>
        <Backdrop className={classes.backdrop}  open={this.state.cargando}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <div align='center' style={{marginTop:10}}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                <KeyboardDatePicker
                  variant="inline" inputVariant="outlined"
                  format="dd / MM / yyyy" margin="dense"                                   
                  label={'Fecha Desde:'}
                  value={this.state.fechadesde}
                  onChange={this.handleDateChange_desde}                                                                                                                                                                                
                  InputProps={{ style:{ paddingRight: '1px' },readOnly: true }}    
                  style={{ marginTop: 5, width: !movil_pequeño ? '100px' : '100%' }}
                  className = {classes.textField} ToolbarComponent={CustomToolbar}  
                  autoOk                    
                />
            </MuiPickersUtilsProvider> 
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                <KeyboardDatePicker
                  variant="inline" inputVariant="outlined"
                  format="dd / MM / yyyy" margin="dense"
                  disabled={this.state.fechadesde===null}                              
                  label={'Fecha Hasta:'}
                  value={this.state.fechahasta}
                  onChange={this.handleDateChange_hasta}                                                                                                                                                                                
                  InputProps={{ style:{ paddingRight: '1px'},readOnly: true }}    
                  style={{ marginTop: 5, width: !movil_pequeño ? '100px' : '100%' }}
                  className = {classes.textField} ToolbarComponent={CustomToolbar}       
                  autoOk               
                />
            </MuiPickersUtilsProvider> 
        </div>
      <div ref={this.tablaRef} style={{marginTop:10,background:'white',marginLeft:movil_pequeño?globales.tabla.marginleft_movil:globales.tabla.marginleft,marginRight:movil_pequeño?globales.tabla.marginright_movil:globales.tabla.marginright}}>
        <CustomTable
            Columns={columns}                                    
            Rows={this.state.rows_principal}                                          
            TableColumnExtensions={tableColumnExtensions}
            DefaultHiddenColumnNames={defaultHiddenColumnNames}
            getRowId = {getRowId}
            height={this.state.heightTableMain}
            ExpandedRowDetailIds = {this.state.expandedRowIds}
            onExpandedRowDetailIdsChange={this.onExpandedRowDetailIdsChange}
            enabledFilterRows= {false}
            RowDetail={this.RowDetail}
            standarPlugin = { <TableRowsIndexer/> }
            VirtualTable_cellComponent={VirtualTable_cellComponent}
            showSelectionColumn={false}
        />
      </div>
    </React.Fragment>
    ); /// finaliza return
    }
    else if (this.state.isLoggin === false)
    {
        Auth.logout()
        window.location.reload();
        return; 
    }


    return null;
} /// finaliza render
} /// finaliza class
)/// finaliza withStyles